import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeleteResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeleteResponseDTO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly data: RoomBrandOverlayDeleteResponse) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayDeleteResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayDeleteResponse {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
